"use strict";
const tokenizer_1 = require("./tokenizer");
const parser_1 = require("./parser");
const transformer_1 = require("./transformer");
const code_generator_1 = require("./code-generator");
module.exports = {
    tokenize: tokenizer_1.tokenize,
    parse: parser_1.parse,
    transform: transformer_1.transform,
    generate: code_generator_1.generate,
};
